import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import { motion, useAnimation } from "framer-motion";
import { HackText } from "react-hacker-text-effect";
import { useInView } from "react-intersection-observer";

import linkedin from "../icons/linkedin.svg";
import github from "../icons/github.svg";
import rocket from "../img/rocket.json";
import GradientButton from "./GradientButton";

//
//

const Intro = () => {
  const [spd, setSpd] = useState(0.7);
  const controls = useAnimation();
  const [ref, inView] = useInView();

  const fade = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  useEffect(() => {
    setSpd(0.5);
    if (inView) {
      controls.start("visible");
    }

    return () => {
      controls.start("hidden");
    };
  }, [controls, inView]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: rocket,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="container">
      <div className="shell ">
        <AllIntro>
          <IntroContainer>
            <p>Hi, my name is</p>

            <motion.div
              ref={ref}
              animate={controls}
              initial="hidden"
              transition={{ duration: 1 }}
              variants={fade}
            >
              <motion.h2 className="gradient-text">Vishnu Rupan</motion.h2>
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                default: { duration: 3 },
              }}
              className="intro-desc"
            >
              I'm a Developer & UI/UX Designer
            </motion.p>

            <div className="link-btn">
              <GradientButton to={"project"} name={"Project"} type={"page"} />
              <GradientButton to={"project"} name={"Designs"} type={"page"} />
            </div>

            <div className="contact-social">
              <a
                href="https://www.linkedin.com/in/vishnu-santharupan"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedin} alt="linkedin.com/in/vishnu-santharupan" />
              </a>
              <a href="https://github.com/VishnuRupan" target="_blank">
                <img src={github} alt="GitHub.com/VishnuRupan" />
              </a>
            </div>
          </IntroContainer>

          <div className="f-tech-img">
            <Lottie
              style={{ margin: "0px" }}
              options={defaultOptions}
              height={500}
              width={400}
              speed={spd}
            />

            {inView && <HackText word="ENCRYPTED" textSize="0.6rem" />}
          </div>

          <div className="w-tech-img">
            <Lottie
              style={{ margin: "0px" }}
              options={defaultOptions}
              height={400}
              width={350}
              speed={spd}
            />
          </div>
        </AllIntro>
      </div>
    </div>
  );
};

export default Intro;

const AllIntro = styled(motion.div)`
  display: flex;
  min-height: 100vh;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .f-tech-img {
    @media (max-width: 1024px) {
      display: none;
    }
  }

  .w-tech-img {
    display: none;
    @media (max-width: 1024px) {
      display: flex;
    }

    @media (max-width: 750px) {
      display: none;
    }
  }

  //  Media Queries

  @media (max-width: 750px) {
    justify-content: center;
    text-align: center;
  }
`;

const IntroContainer = styled(motion.div)`
  .gradient-text {
    background-image: linear-gradient(45deg, #962dce, #6de8fb);
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    font-size: 5.5rem;
    font-family: "Work Sans", sans-serif;

    //  Media Queries
    @media (max-width: 750px) {
      font-size: 4rem;
    }

    @media (max-width: 400px) {
      font-size: 3rem;
    }
  }

  p {
    font-size: 1.1rem;
    font-weight: 300;
    letter-spacing: 0.03rem;
    padding: 1rem 0rem;

    @media (max-width: 400px) {
      font-size: 0.8rem;
    }
  }

  .link-btn {
    display: flex;
    justify-content: space-between;
    width: 18rem;
    padding-top: 2rem;
    z-index: 2;

    @media (max-width: 750px) {
      width: 100%;
      justify-content: center;
      text-align: center;

      button {
        margin: 0rem 0.8rem;
      }
    }
  }

  .contact-social {
    padding-top: 3rem;
    width: 6rem;
    display: flex;
    justify-content: space-between;

    img {
      cursor: pointer;

      &:hover {
        box-shadow: 1px 2px 4px rgba(162, 162, 162, 0.4);
      }
    }

    @media (max-width: 750px) {
      width: 100%;
      justify-content: center;
      text-align: center;

      img {
        margin: 0rem 1rem;
      }
    }
  }
`;
